import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "src/@/components/ui/dialog";
import { Input } from "src/@/components/ui/input";
import { Textarea } from "src/@/components/ui/textarea";
import { Switch } from "src/@/components/ui/switch";
import { Button } from "src/@/components/ui/button";
import DatePicker from "src/@/components/shared/datePickers/DatePicker";
import { Divider } from "@mui/material";
import { RowInput } from "src/components/forms/RowInput";
import v2_actionCalendarioCriarEvento from "src/actions/v2/calendario/v2_actionCalendarioCriarEvento";
import { format } from "date-fns";

const AddEventDialog = ({ user, isEdit, event, open, onOpenChange, onOpen, onClose, changeValue, onCreate, onEdit }) => {

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};

    // Validação do título
    if (!event?.title || event.title.trim() === "") {
      newErrors.title = "O título é obrigatório.";
    }

    // Validação para eventos não "Dia inteiro"
    if (!event?.allDay) {
      // Validação do horário inicial
      if (!event?.time_start || !/^\d{2}:\d{2}$/.test(event.time_start)) {
        newErrors.time_start = "Horário inicial deve estar no formato HH:mm.";
      }

      // Validação do horário final
      if (!event?.time_end || !/^\d{2}:\d{2}$/.test(event.time_end)) {
        newErrors.time_end = "Horário final deve estar no formato HH:mm.";
      }

      // Validação das datas
      if (event?.startDate && event?.endDate) {
        const start = new Date(event.startDate);
        const end = new Date(event.endDate);

        // Data final não pode ser menor que a data inicial
        if (start > end) {
          newErrors.dates = "A data final deve ser maior ou igual à data inicial.";
        }

        // Validação dos horários, se as datas forem iguais
        if (start.toDateString() === end.toDateString()) {
          const [startHours, startMinutes] = (event.time_start || "00:00").split(":").map(Number);
          const [endHours, endMinutes] = (event.time_end || "00:00").split(":").map(Number);

          const startTime = startHours * 60 + startMinutes; // Convertendo para minutos
          const endTime = endHours * 60 + endMinutes; // Convertendo para minutos

          if (endTime <= startTime) {
            newErrors.time_end = "Horário final deve ser maior que o horário inicial no mesmo dia.";
          }
        }
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Retorna verdadeiro se não houver erros
  };

  function handleClose() {
    onClose();
    setErrors({});
  }


  async function handleCreate() {
    if (validate()) {
      onCreate();
      handleClose();
    }
  }

  async function handleEdit() {
    if (validate()) {
      onEdit();
      handleClose();
    }
  }

  const tabs = [
    { id: "simple_event", label: "Evento Simples" },
    { id: "taks", label: "Tarefa" },
    { id: "schedule", label: "Agendamento de horários" },
  ];

  const tabsOrigem = [
    { id: "lais", label: "Lais" },
    // { id: "google", label: "Google Calendário" },
  ];

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogTrigger asChild>
        <Button className="bg-violet-700 hover:bg-violet-400" onClick={onOpenChange}>{!isEdit ? "Criar evento" : "Editar evento"}</Button>
      </DialogTrigger>
      <DialogContent className="min-w-[900px]">
        <DialogHeader>
          <DialogTitle>{!isEdit ? "Novo evento" : "Editar evento"}</DialogTitle>
        </DialogHeader>
        <Divider sx={{ borderStyle: 'dashed' }} />
        <div className="space-y-4 p-4 flex flex-col gap-2">
          {/* Título e Descrição */}

          <div className="flex space-x-2 bg-gray-100 p-1 rounded-md w-max">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`px-4 py-1 rounded-md text-sm ${event?.event_type === tab.id
                  ? "bg-violet-500 text-white font-semibold"
                  : "text-gray-500"
                  }`}
                onClick={() => {
                  let event = {
                    target: {
                      name: "event_type",
                      value: tab.id
                    }
                  }
                  changeValue(event)
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>



          <div className="w-1/2">
            <RowInput
              label="Título"
              isRequired
              input={<Input
                value={event?.title}
                name="title"
                onChange={changeValue}
                placeholder="Adicionar título"
              />}
            />

          </div>

          {/* Data e Hora */}
          <div className="flex flex-row gap-2 items-center">
            <div>
              <DatePicker
                label="Data Inicial"
                selectedDate={event?.startDate || new Date()}
                name="startDate"
                onSelect={value => {
                  let event = {
                    target: {
                      name: "startDate",
                      value: value
                    }
                  }
                  changeValue(event)
                }}
              />
            </div>
            {!event?.allDay && (
              <div className="flex flex-row gap-2">
                <div className="w-24">
                  <label className="text-sm text-gray-600">hora inicial</label>
                  <input
                    type="time"
                    value={event?.time_start}
                    name="time_start"
                    onChange={changeValue}
                    className="border px-2 h-8 rounded-md mt-1.5 w-full bg-slate-100"
                  />
                </div>

              </div>
            )}
            <>

            </>

            <div>
              <DatePicker
                label="Data Final"
                selectedDate={event?.endDate || new Date()}
                name="endDate"
                onSelect={value => {
                  let event = {
                    target: {
                      name: "endDate",
                      value: value
                    }
                  }
                  changeValue(event)
                }}
              />

            </div>

            {!event?.allDay && (
              <div className="w-24">
                <label className="text-sm text-gray-600">Final</label>
                <input
                  type="time"
                  name="time_end"
                  value={event?.time_end}
                  onChange={changeValue}
                  className="border px-2 h-8 rounded-md mt-1.5 w-full bg-slate-100"
                />
              </div>

            )}
          </div>

          {/* Dia Todo */}
          <div className="flex items-center space-x-2">
            <Switch name="allDay" checked={event?.allDay} onCheckedChange={value => {
              let event = {
                target: {
                  name: "allDay",
                  value: value
                }
              }
              changeValue(event)
            }} />
            <label>Dia inteiro</label>
          </div>

          <div>
            <label className="text-sm text-gray-600">Descrição</label>
            <Textarea
              className="w-1/2"
              name="description"
              value={event?.description}
              onChange={changeValue}
              placeholder="Descrição"
            />

          </div>

          <div>
            <label className="text-sm text-gray-600">Link da reunião</label>
            <Input
              className="w-1/2"
              name="link"
              value={event?.link}
              onChange={changeValue}
              placeholder="Descrição"
            />

          </div>

          <div>
            {errors.title && <p className="text-red-500 text-sm">{errors.title}</p>}
            {errors.time_start && <p className="text-red-500 text-sm">{errors.time_start}</p>}
            {errors.dates && <p className="text-red-500 text-sm">{errors.dates}</p>}
            {errors.time_end && <p className="text-red-500 text-sm">{errors.time_end}</p>}
          </div>

          {/* <div className="flex flex-col gap-1">
            <label className="text-sm text-gray-600">Origem</label>
            <div className="flex space-x-2 bg-gray-100 p-1 rounded-md w-max">

              {tabsOrigem.map((tab) => (
                <button
                  key={tab.id}
                  className={`px-4 py-1 text-sm rounded-md ${activeTabOrigem === tab.id
                    ? "bg-violet-500 text-white font-semibold"
                    : "text-gray-500"
                    }`}
                  onClick={() => setActiveTabOrigem(tab.id)}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div> */}

        </div>

        <Divider sx={{ borderStyle: 'dashed' }} />

        {/* Ações */}
        <div className="flex justify-end space-x-2 mt-2">
          <Button onClick={handleClose} variant="outline">
            Cancelar
          </Button>
          <Button onClick={isEdit ? handleEdit : handleCreate} >{!isEdit ? "Criar evento" : "Editar evento"}</Button>
        </div>

      </DialogContent>
    </Dialog>
  );
};

export default AddEventDialog;
